/** Super-admin STT routing (Cloud Run + Admin). Extend providers/presets as backends are added. */

export const STT_PROVIDER_IDS = ['google_v1', 'assemblyai'] as const;
export type SttProviderId = (typeof STT_PROVIDER_IDS)[number];

export const STT_PRESET_IDS = ['balanced', 'long_form', 'short_clips'] as const;
export type SttPresetId = (typeof STT_PRESET_IDS)[number];

export function isSttProviderId(value: unknown): value is SttProviderId {
  return typeof value === 'string' && (STT_PROVIDER_IDS as readonly string[]).includes(value);
}

export function isSttPresetId(value: unknown): value is SttPresetId {
  return typeof value === 'string' && (STT_PRESET_IDS as readonly string[]).includes(value);
}

export const DEFAULT_STT_PROVIDER: SttProviderId = 'assemblyai';
export const DEFAULT_STT_PRESET: SttPresetId = 'balanced';
